import '../../styles/crud-review.scss';
import {Button} from 'forms';
import {CollectionField} from '../fields';
import {Dictionary} from 'lodash';
import {FieldSchema} from '../types';
import CrudHub from '../CrudHub';
import {PanelRenderer} from '../renderers';
import noop from 'lodash/noop';
import React from 'react';
import t from 'rcm-i18n';

interface Props {
    creates: Dictionary<any>;
    deletes: Dictionary<any>;
    getValue: (id: any) => any;
    onCancel?: () => void;
    onSubmit?: () => void;
    schema: FieldSchema[];
    updates: Dictionary<any>;
}

const CrudReview = ({
    creates = {},
    deletes = {},
    getValue,
    onCancel = noop,
    onSubmit = noop,
    schema = [],
    updates = {},
}: Props) => {
    const schemaReview = schema
        .filter((f) => !f.hidden)
        .map((f) => ({ ...f, Type: null, props: { } }));
    return <div className="crud-review">
        <div>
            {Object.entries(creates).map(([id, v]) => <CollectionField key={id}
                Renderer={PanelRenderer}
                panel="info"
                label={t('Create')}
                schema={schemaReview}
                value={v}
            />)}
        </div>
        <div>
            {Object.entries(updates).map(([id, v]) => <div key={id}>
                <CollectionField Renderer={PanelRenderer}
                    panel="warning"
                    label={t('Change')}
                    schema={schemaReview}
                    value={getValue(id)}
                />
                <CollectionField
                    Renderer={PanelRenderer}
                    panel="warning"
                    schema={schemaReview}
                    value={v}
                />
            </div>)}
        </div>
        <div>
            {Object.entries(deletes).map(([id, v]) => <CollectionField key={id}
                Renderer={PanelRenderer}
                panel="danger"
                label={t('Delete')}
                schema={schemaReview}
                value={v}
            />)}
        </div>
        <CrudHub.Foot.Send>
            <Button btn="default"
                className="pull-left"
                icon="chevron-left"
                onClick={onCancel}
                text={t('Back')}
            />
            <Button btn="primary"
                className="pull-right"
                onClick={onSubmit}
                text={t('Save All Changes')}
                icon="floppy-save"
            />
        </CrudHub.Foot.Send>
    </div>;
};

export default CrudReview;
